var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8ZM8.50001 4.00009C8.94184 4.00009 9.30001 4.35826 9.30001 4.80009V7.19999H11.7001C12.1419 7.19999 12.5001 7.55816 12.5001 7.99999C12.5001 8.44182 12.1419 8.79999 11.7001 8.79999H9.30001V11.2001C9.30001 11.6419 8.94184 12.0001 8.50001 12.0001C8.05819 12.0001 7.70001 11.6419 7.70001 11.2001V8.79999H5.30011C4.85828 8.79999 4.50011 8.44182 4.50011 7.99999C4.50011 7.55816 4.85828 7.19999 5.30011 7.19999H7.70001V4.80009C7.70001 4.35826 8.05819 4.00009 8.50001 4.00009Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockAddIcon);
export default __webpack_public_path__ + "static/media/stockAddIcon.e86d737e71e9e79325a50e2bc11e89fb.svg";
export { ForwardRef as ReactComponent };